// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import {AXIOSAPI} from '@sdgsystems/vue-common/components/requests-common'
import {ENDPOINT} from '@/shared/constants'

class ApiRequests {

  static createImage (file, config = null) {
    let url = ENDPOINT + 'images'
    return AXIOSAPI.post(url, file, config)
  }

  static deleteImages (query) {
    var url = ENDPOINT + 'images'
    return AXIOSAPI.delete(url, { 'params': query })
  }

  static getImages (params) {
    var url = ENDPOINT + 'images'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getImageCategories (params) {
    let url = ENDPOINT + 'image-categories'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getImageProperties (id) {
    let url = ENDPOINT + 'images/' + id + '/meta'
    return AXIOSAPI.get(url)
  }

  static putImageProperties (id, properties) {
    let url = ENDPOINT + 'images/' + id + '/meta'
    return AXIOSAPI.put(url, { photo: properties })
  }

  static getConfiguration () {
    var params = {}
    var url = ENDPOINT + 'config/settings'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getOrganizations () {
    var params = {}
    var url = ENDPOINT + 'organizations'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getRoles () {
    var params = {}
    var url = ENDPOINT + 'roles'
    params.sort = 'name'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getSettings () {
    var params = {}
    var url = ENDPOINT + 'settings'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static putSettings (value) {
    var params = {}
    var url = ENDPOINT + 'settings'
    return AXIOSAPI.put(url, value, { 'params': params })
  }

  // Gets current storage usage for the current org
  static getStorageUsage () {
    var params = {}
    var url = ENDPOINT + 'admin/storageusage'
    return AXIOSAPI.get(url, { 'params': params })
  }

  // Gets cached storage usage for the current org
  static getCachedUsage () {
    var params = {}
    var url = ENDPOINT + 'usage'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static deleteUser (id) {
    var url = ENDPOINT + 'users/' + id
    return AXIOSAPI.delete(url)
  }

  static getUser (id) {
    var url = ENDPOINT + 'users/' + id
    return AXIOSAPI.get(url)
  }

  static getUsers () {
    var params = {}
    var url = ENDPOINT + 'users'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getUsernames () {
    var params = {}
    var url = ENDPOINT + 'usernames'
    return AXIOSAPI.get(url, { 'params': params })
  }

  static getUsername (id) {
    var url = ENDPOINT + 'usernames/' + id
    return AXIOSAPI.get(url)
  }

  static getUserSettings (id) {
    var url = ENDPOINT + 'usersettings/' + id
    return AXIOSAPI.get(url)
  }

  static putUserSettings (userSettings) {
    var params = {}
    var url = ENDPOINT + 'usersettings/' + userSettings.userId
    return AXIOSAPI.put(url, userSettings, { 'params': params })
  }

  static postUser (user, email) {
    var params = {}
    if (email) {
      params.email = true
    }
    var url = ENDPOINT + 'users'
    return AXIOSAPI.post(url, user, { 'params': params })
  }

  static putUser (user) {
    var params = {}
    var url = ENDPOINT + 'users/' + user.id
    return AXIOSAPI.put(url, user, { 'params': params })
  }

  static getWebhook (id) {
    var url = ENDPOINT + 'webhooks/' + id
    return AXIOSAPI.get(url)
  }

  static postWebhook (webhook) {
    var params = {}
    var url = ENDPOINT + 'webhooks'
    return AXIOSAPI.post(url, webhook, { 'params': params })
  }

  static putWebhook (webhook) {
    var params = {}
    var url = ENDPOINT + 'webhooks/' + webhook.id
    return AXIOSAPI.put(url, webhook, { 'params': params })
  }

  static deleteImage (id) {
    let url = ENDPOINT + 'images/' + id
    return AXIOSAPI.delete(url)
  }

  static oktaAvailable () {
    let url = '/auth/okta/available'
    return AXIOSAPI.get(url)
  }
}

export default ApiRequests



// WEBPACK FOOTER //
// ./src/api/ApiRequests.js